import React from 'react';
import { Container } from 'react-bootstrap';
import './Pools.scss';
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */

export default function Pools() {
    return (
        <div className="pools-container pool-circle circle-mobile" id="Pools">
            <Container style={{ position: 'relative' }}>
                <h1 className="padin-pools text-center pools__heading">Pools</h1>
                <div className="pool-im" />
                <div className="illustrative-only">
                    *This content is for illustrative purpose only
                </div>
            </Container>
        </div>
    );
}
